import { render } from "./ChamadosPorProgramador.vue?vue&type=template&id=c497482a"
import script from "./ChamadosPorProgramador.vue?vue&type=script&lang=js"
export * from "./ChamadosPorProgramador.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__